import Axios from 'axios'
import {API_ROOT} from '../../config'



var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000

});
console.log(API_ROOT);

export default {
  state: {
    firstlogin: {}
  },
  mutations: {
    FIRSTLOGIN(state, obj) {
      console.log('FIRSTLOGIN');
      state.firstlogin = obj;
    }
  },
  getters: {
    getFirstlogin(state) {
      console.log('Get FIRSTLOGIN');
      return state.firstlogin;
    },
  },
  actions: {
    firstlogin(context, obj) {
        console.log('Do FIRSTLOGIN');

      instance.post('/user/firstlogin/', obj).then(function(response) {
        console.log(response.data);
        var obj = response.data;

        context.commit('FIRSTLOGIN', obj);

      }).catch(function(error) {
        console.log(error);
      });
    }
  }
}
